import { memo, useEffect, useRef, useState } from 'react';
import { Box, Button, CardContent, FormHelperText, InputLabel, MenuItem, Select, TextField, Typography, FormControl, Grid } from "@mui/material";
import React from "react";
import { nextStep, update } from '../../../../../slice/multiStepSlice';
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useMutation } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { z } from "zod";
import showToast from "../../../../../components/Hot-Toast/showToast";
import { useTMutation } from "../../../../../utils/useTMutation";

export const HealthDocuments = z.object({
    DOCUMENT_NAME: z.string().min(1, { message: "Health Document is Required" }),
    REQUIREMENT: z.string().min(1, { message: "Requirments is Required" }),
});

// export default function AddNewDoc() {
const AddNewDoc = ({ data }) => {

    const dispatch = useDispatch();
    const { values } = useSelector((state) => state?.multiStep)

    const {
        register,
        setValue,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        resolver: zodResolver(HealthDocuments),
        defaultValues: { DOCUMENT_NAME: values.DOCUMENT_NAME || '', REQUIREMENT: values.REQUIREMENT || '' } // Ensure default values
    });

    const { mutateAsync } = useTMutation("/addHealthDocument", "post", (response) => {
        if (response.STATUS) {
            return response;
        }
    });
    console.log("sdjss", values.ID)

    const submitHealthDocuments = async (data) => {
        if (values.ID) data.ID = values.ID
        console.log("Data", data)
        try {
            const response = await mutateAsync(data);
            console.log("sssss", response);
            if (response.STATUS) {
                dispatch(update(values.ID ? data : response.OUTPUT));
                dispatch(nextStep())
            } else {
                showToast("error", data.MESSAGE, 3000);
            }
        } catch (error) {
            console.error("Add Request failed:", error);
            showToast("error", "Something went wrong, Please try again", 3000);
        }
    };

    // const handleNextStep = () => {

    // dispatch(nextStep());
    // };

    return (


        <Grid lg={12} >
            <CardContent className='gridcardcontent gridtextdata'>

                <Typography variant="h2" component="div"  fontWeight="bold" style={{marginTop:-4}}>
                    Add New Document
                </Typography>

                <form onSubmit={handleSubmit(submitHealthDocuments)}>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        <TextField
                            label="Document Name"
                            variant="outlined"
                            fullWidth
                             className='document_name'
                            margin="normal"
                            autoFocus
                            // InputProps={{ style: { height: '50px' } }}
                            sx={{
                                '& .MuiOutlinedInput-input': {
                                    padding: 1.94
                                },
                                '& .MuiFormHelperText-root': {
                                    marginLeft: 0,
                                    marginTop: '4px',
                                },
                            }}
                            {...register("DOCUMENT_NAME")}
                            error={!!errors.DOCUMENT_NAME}
                            helperText={errors.DOCUMENT_NAME?.message}
                        />

                        <FormControl fullWidth sx={{ marginTop: 3 }} error={!!errors.REQUIREMENT}>
                            
                            <Controller
                                name="REQUIREMENT"
                            
                                control={control}
                                render={({ field }) => (
                                    <>
                                    <InputLabel id="demo-simple-select-label">Requirement</InputLabel>
                                    <Select
                                        // autoFocus
                                        labelId="demo-simple-select-label"
                                        className='document_name'
                                        id="requirement-select"
                                        label="Requirement"
                                        {...field}
                                        error={!!errors.REQUIREMENT}
                                    >
                                        <MenuItem value="true">Required</MenuItem>
                                        <MenuItem value="false">Not Required</MenuItem>
                                    </Select></>
                                )}
                            />
                            {errors.REQUIREMENT && <FormHelperText>{errors.REQUIREMENT?.message}</FormHelperText>}
                        </FormControl>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end',  }}>
                            <Button 
                             className='gradientAdminThemeColor'
                            // variant="contained" sx={{ backgroundColor: '#6ebe44' }}
                                type='submit'>
                                Next
                            </Button>
                        </Box>
                    </Box>


                </form>
            </CardContent>
        </Grid>
    )
};
export default memo(AddNewDoc);






// import { memo, useEffect, useRef, useState } from 'react';
// import { Box, Button, CardContent, FormHelperText, InputLabel, MenuItem, Select, TextField, Typography, FormControl, Grid } from "@mui/material";
// import React from "react";
// import { nextStep, update } from '../../../../../slice/multiStepSlice';
// import { Controller, useForm } from "react-hook-form";
// import { zodResolver } from "@hookform/resolvers/zod";
// import { useMutation } from "@tanstack/react-query";
// import { useDispatch, useSelector } from "react-redux";
// import { z } from "zod";
// import showToast from "../../../../../components/Hot-Toast/showToast";
// import { useTMutation } from "../../../../../utils/useTMutation";
// import CameraAltIcon from "@mui/icons-material/CameraAlt";

// export const HealthDocuments = z.object({
//     DOCUMENT_NAME: z.string().min(1, { message: "Health Document is Required" }),
//     REQUIREMENT: z.string().min(1, { message: "Requirments is Required" }),
// });

// // export default function AddNewDoc() {
// const AddNewDoc = ({ data }) => {

//     const dispatch = useDispatch();
//     const { values } = useSelector((state) => state?.multiStep)

//     const {
//         register,
//         setValue,
//         handleSubmit,
//         control,
//         formState: { errors },
//     } = useForm({
//         resolver: zodResolver(HealthDocuments),
//         defaultValues: { DOCUMENT_NAME: values.DOCUMENT_NAME || '', REQUIREMENT: values.REQUIREMENT || '' } // Ensure default values
//     });

//     const { mutateAsync } = useTMutation("/addHealthDocument", "post", (response) => {
//         if (response.STATUS) {
//             return response;
//         }
//     });
//     console.log("sdjss", values.ID)

//     const submitHealthDocuments = async (data) => {
//         if (values.ID) data.ID = values.ID
//         console.log("Data", data)
//         try {
//             const response = await mutateAsync(data);
//             console.log("sssss", response);
//             if (response.STATUS) {
//                 dispatch(update(values.ID ? data : response.OUTPUT));
//                 dispatch(nextStep())
//             } else {
//                 showToast("error", data.MESSAGE, 3000);
//             }
//         } catch (error) {
//             console.error("Add Request failed:", error);
//             showToast("error", "Something went wrong, Please try again", 3000);
//         }
//     };

//     // const handleNextStep = () => {

//     // dispatch(nextStep());
//     // };

//     return (


//         <Grid lg={12} >
//             <CardContent className='gridcardcontent gridtextdata'>

//                 <Typography variant="h2" component="div"  fontWeight="bold" style={{marginTop:-4}}>
//                 Add Training
//                 </Typography>

//                   {/* Profile Image Upload Section */}
//         <Box position="relative" display="inline-block" mb={2}>
//           <Avatar
//             src={image}
//             sx={{ width: 150, height: 150, mx: "auto", borderRadius: 2  }}
//           />
//           <IconButton
//             component="label"
//             sx={{
//               position: "absolute",
//               bottom: 0,
//               right: 0,
//               backgroundColor: "white",
//               boxShadow: 1,
//             }}
//           >
//             <CameraAltIcon fontSize="small" />
//             <input type="file" hidden accept="image/*" onChange={handleImageUpload} />
//           </IconButton>
//         </Box>

//                 <form onSubmit={handleSubmit(submitHealthDocuments)}>

//                     <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
//                         <TextField
//                             label="Training Name"
//                             variant="outlined"
//                             fullWidth

//                             margin="normal"
//                             autoFocus
//                             // InputProps={{ style: { height: '50px' } }}
//                             sx={{
//                                 '& .MuiOutlinedInput-input': {
//                                     padding: 1.94
//                                 },
//                                 '& .MuiFormHelperText-root': {
//                                     marginLeft: 0,
//                                     marginTop: '4px',
//                                 },
//                             }}
//                             {...register("DOCUMENT_NAME")}
//                             error={!!errors.DOCUMENT_NAME}
//                             helperText={errors.DOCUMENT_NAME?.message}
//                         />

//                         <FormControl fullWidth sx={{ marginTop: 3 }} error={!!errors.REQUIREMENT}>
                            
//                             <Controller
//                                 name="REQUIREMENT"
                            
//                                 control={control}
//                                 render={({ field }) => (
//                                     <>
//                                     <InputLabel id="demo-simple-select-label">Requirement</InputLabel>
//                                     <Select
//                                         // autoFocus
//                                         labelId="demo-simple-select-label"
//                                         id="requirement-select"
//                                         label="Requirement"
//                                         {...field}
//                                         error={!!errors.REQUIREMENT}
//                                     >
//                                         <MenuItem value="true">Required</MenuItem>
//                                         <MenuItem value="false">Not Required</MenuItem>
//                                     </Select></>
//                                 )}
//                             />
//                             {errors.REQUIREMENT && <FormHelperText>{errors.REQUIREMENT?.message}</FormHelperText>}
//                         </FormControl>
//                         <Box sx={{ display: 'flex', justifyContent: 'flex-end',  }}>
//                             <Button 
//                              className='gradientAdminThemeColor'
//                             // variant="contained" sx={{ backgroundColor: '#6ebe44' }}
//                                 type='submit'>
//                                 Next
//                             </Button>
//                         </Box>
//                     </Box>


//                 </form>
//             </CardContent>
//         </Grid>
//     )
// };
// export default memo(AddNewDoc);









